function shouldUseRemoteJsNavigation(path, sourceItem) {
  const label = String(sourceItem?.label || '').toLowerCase();
  return (
    label === 'search' ||
    label === 'ask llamabot' ||
    /\/global_search\/new(?:\?|$)/.test(String(path || ''))
  );
}

function isGlobalSearchNavItem(path, sourceItem) {
  const label = String(sourceItem?.label || '').toLowerCase();
  return label === 'search' || /\/global_search\/new(?:\?|$)/.test(String(path || ''));
}

function submitRailsDeleteNavigation(path) {
  if (typeof document === 'undefined') return false;

  const form = document.createElement('form');
  form.method = 'POST';
  form.action = path;
  form.style.display = 'none';

  const methodInput = document.createElement('input');
  methodInput.type = 'hidden';
  methodInput.name = '_method';
  methodInput.value = 'delete';
  form.appendChild(methodInput);

  const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
  if (csrfToken) {
    const csrfParam = document.querySelector('meta[name="csrf-param"]')?.getAttribute('content')
      || 'authenticity_token';
    const csrfInput = document.createElement('input');
    csrfInput.type = 'hidden';
    csrfInput.name = csrfParam;
    csrfInput.value = csrfToken;
    form.appendChild(csrfInput);
  }

  document.body.appendChild(form);
  form.submit();
  return true;
}

export { shouldUseRemoteJsNavigation, isGlobalSearchNavItem, submitRailsDeleteNavigation };
